/** The one list of share card templates. The server's copy is Services/ShareCards/ShareTemplate.cs. */
export const SHARE_TEMPLATES = [['ring', 'RING'], ['streak', 'STREAK'], ['marquee', 'MARQUEE']];

export const isShareTemplate = (v) => SHARE_TEMPLATES.some(([key]) => key === v);

/** Unknown or empty always means ring. */
export const shareTemplate = (v) => (isShareTemplate(v) ? v : 'ring');
